import Typography from '@mui/material/Typography'
import { FC } from 'react'
import mlEmployeesClapping from '../../../../public/assets/ml-employees-clapping.png'
import ImageFirstSection from '../../../shared/components/ImageFirstSection'
import { colors } from '../../../shared/theme/colors'

const WhyWorkSection: FC = () => (
  <ImageFirstSection
    imageSrc={mlEmployeesClapping}
    imageAltText="Mission Lane employees clapping"
    backgroundColor="darkGreen"
    imageWidth="wide"
  >
    <Typography variant="h2" sx={{ color: colors.White }} className="mb-4 md:mb-6">
      Why work at Mission Lane?
    </Typography>
    <Typography variant="p1" sx={{ color: colors.Green[200] }} className="hidden md:block mb-6">
      Mission Lane empowers consumers striving for a better financial future by combining the
      agility of a modern fintech with the discipline of an established institution.
    </Typography>
    <Typography variant="p1" sx={{ color: colors.Green[200] }} className="hidden md:block">
      We&apos;ve hit our stride as a leader in our space, but there are still meaningful problems to
      solve and systems to design. We&apos;re looking for the people who will drive us into the
      future as we accelerate momentum and expand what&apos;s possible for our customers.
    </Typography>
    <Typography variant="p1" sx={{ color: colors.White }} className="md:hidden mb-6">
      Mission Lane empowers consumers striving for a better financial future by combining the
      agility of a modern fintech with the discipline of an established institution.
    </Typography>
    <Typography variant="p1" sx={{ color: colors.White }} className="md:hidden">
      We&apos;ve hit our stride as a leader in our space, but there are still meaningful problems to
      solve and systems to design. We&apos;re looking for the people who will drive us into the
      future as we accelerate momentum and expand what&apos;s possible for our customers.
    </Typography>
  </ImageFirstSection>
)

export default WhyWorkSection
